import React from 'react';
import clsx from 'clsx';

import Container from '@common/Container';
import Section from '@common/Section';
import Row from '@common/Row';
import RichText from '@common/RichText';
import SmallTitle from '@common/SmallTitle';
import CustomerStoriesFilter from '@components/resources/CustomerStoriesFilter';

const FilterCustomerStories = ({ data }) => {
  const {
    title,
    showTitle,
    text,
    textAlignment,
    listClass,
    topMargin,
    bottomMargin,
    bgColour,
    bgNoPadding,
    bgFullwidth
  } = data;
  return (
    <Section spacing={clsx(topMargin, bottomMargin, {
      [`bg-${bgColour} rounded`]: bgColour && bgFullwidth,
      'py-5': bgColour && !bgNoPadding,
      })}>
      <Container>
        <Row className='d-flex flex-column'>
          {(showTitle && title) &&
            <SmallTitle>{title}</SmallTitle>
          }
          {text &&
            <div className={clsx('col col-lg-7', {
                'text-center': textAlignment === 'Center',
                'text-end': textAlignment === 'Right',
                'text-start': textAlignment === 'Left',
              })}>
              {text &&
                <RichText
                  json={text}
                  h1='mb-3'
                  h2='mb-3'
                  p='mb-3'
                  ul={listClass}
                  li='py-2'
                  a='fs-16'
                />
              }
            </div>
          }
        </Row>
        <CustomerStoriesFilter bgColour={bgColour}/>
      </Container>
    </Section>
  )
}

export default FilterCustomerStories
